export const NAVIGATION_KEYS: readonly string[] = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];

export const CLIPBOARD_SHORTCUT_KEYS: readonly string[] = ['a', 'c', 'v', 'x'];
